import i18n from "i18next";
import React from "react";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

export const SUPPORTED_LANGUAGES = ["en", "de", "tr", "ar"];
export const RTL_LANGUAGES = ["ar"];

export const isRtlLanguage = lng => RTL_LANGUAGES.includes(String(lng || "").split("-")[0]);

export const applyDocumentDirection = lng => {
  if (typeof document === "undefined") return;
  const code = String(lng || "en").split("-")[0];
  const dir = isRtlLanguage(code) ? "rtl" : "ltr";
  document.documentElement.setAttribute("lang", code);
  document.documentElement.setAttribute("dir", dir);
  if (document.body) document.body.setAttribute("dir", dir);
};

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: "en",
    defaultNS: "translation",
    ns: ["translation", "mainHome", "privacy", "dashboard", "mail", "accounting"],
    // Panel keys are the English sentence itself, so ":" must not be read as a
    // namespace prefix ("Address:", "Total:"). Nested keys still use ".".
    nsSeparator: false,
    keySeparator: ".",
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator"],
      caches: ["cookie"],
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng"
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      requestOptions: {
        cache: "no-cache"
      }
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: true,
      bindI18n: "languageChanged",
      bindI18nStore: "added removed",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "em", "span"]
    },
    debug: process.env.NODE_ENV === "development",
    load: "languageOnly",
    cleanCode: true,
    lowerCaseLng: true
  });

applyDocumentDirection(i18n.language);
i18n.on("languageChanged", applyDocumentDirection);

export default i18n;
